import { render } from "./Travels.vue?vue&type=template&id=7e8e9d48&scoped=true"
import script from "./Travels.vue?vue&type=script&lang=js"
export * from "./Travels.vue?vue&type=script&lang=js"

import "./Travels.vue?vue&type=style&index=0&id=7e8e9d48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8e9d48"]])

export default __exports__